import { type FC } from 'react'
import { type DefaultProps } from '../common'

export const IconPasskey: FC<DefaultProps> = ({ className, id, testId, ariaLabel }) => {
  return (
    <svg
      className={className}
      {...(testId ? { 'data-testid': testId } : {})}
      {...(id ? { id } : {})}
      {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
      width="111"
      height="96"
      viewBox="0 0 111 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#lltze18o4a)">
        <circle cx="55.2" cy="48" fill="#e0f2fe" r="48" />
        <path
          d="M100.066 74.547h2.957"
          stroke="#174a6f"
          strokeWidth="1.281"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          clipRule="evenodd"
          d="M83.804 67.394a.24.24 0 0 1 .24-.24h21.696a.24.24 0 0 1 .24.24v9.869a.24.24 0 0 1-.24.24H84.044a.24.24 0 0 1-.24-.24v-9.869z"
          stroke="#174a6f"
          strokeWidth="1.281"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="m90.457 70.85-3.696 3.696M90.457 74.546 86.76 70.85M97.11 70.85l-3.696 3.696M97.11 74.546l-3.696-3.696"
          stroke="#174a6f"
          strokeWidth="1.281"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M87.116 31.767a.2.2 0 0 1-.118-.193c0-.089.02-.172.059-.251a12.452 12.452 0 0 1 4.647-3.937 13.367 13.367 0 0 1 6.008-1.39 13.7 13.7 0 0 1 6.023 1.36 12.409 12.409 0 0 1 4.691 3.908c.059.098.084.177.074.236a.337.337 0 0 1-.103.178.304.304 0 0 1-.222.089c-.089 0-.173-.05-.252-.148a11.589 11.589 0 0 0-4.454-3.73 13.12 13.12 0 0 0-5.757-1.302c-2.032 0-3.937.44-5.713 1.317a12.157 12.157 0 0 0-4.44 3.715c-.078.098-.152.158-.221.177a.301.301 0 0 1-.222-.03zm14.118 14.887c-2.032-.513-3.705-1.529-5.017-3.048-1.312-1.52-1.968-3.364-1.968-5.535 0-.927.34-1.707 1.021-2.338.68-.632 1.495-.947 2.442-.947.947 0 1.76.315 2.442.947a3.065 3.065 0 0 1 1.021 2.338c0 .75.291 1.381.873 1.894.582.513 1.258.77 2.027.77.75 0 1.406-.257 1.969-.77.562-.513.843-1.144.843-1.894 0-2.427-.903-4.46-2.708-6.097-1.806-1.638-3.961-2.457-6.467-2.457s-4.662.82-6.467 2.457c-1.806 1.638-2.708 3.67-2.708 6.097 0 .474.054 1.09.162 1.85.109.76.34 1.623.696 2.59.04.098.04.172 0 .222a.65.65 0 0 1-.148.133.369.369 0 0 1-.252.03c-.088-.02-.153-.08-.192-.178a16.693 16.693 0 0 1-.607-2.294 12.586 12.586 0 0 1-.222-2.353c0-2.545.967-4.72 2.9-6.526 1.934-1.806 4.214-2.708 6.838-2.708 2.683 0 4.987.887 6.911 2.663 1.924 1.776 2.886 3.966 2.886 6.571 0 .908-.336 1.677-1.007 2.309-.671.631-1.48.947-2.427.947-.967 0-1.795-.316-2.486-.947-.69-.632-1.036-1.401-1.036-2.309 0-.77-.281-1.41-.843-1.924a2.866 2.866 0 0 0-1.998-.77c-.77 0-1.44.257-2.013.77a2.477 2.477 0 0 0-.858 1.924c0 2.052.621 3.764 1.865 5.135 1.243 1.371 2.792 2.333 4.646 2.886.119.04.193.089.222.148a.29.29 0 0 1 .015.207c-.02.099-.059.168-.118.207-.059.04-.138.04-.237 0zm-10.448-21.31c-.099.04-.173.044-.222.015a.426.426 0 0 1-.133-.133c-.04-.04-.06-.099-.06-.178a.2.2 0 0 1 .09-.177 15.334 15.334 0 0 1 3.536-1.392 14.923 14.923 0 0 1 3.715-.473c1.282 0 2.54.158 3.774.473 1.233.316 2.412.76 3.536 1.332.099.04.153.099.163.178a.297.297 0 0 1-.044.207.48.48 0 0 1-.163.148c-.069.04-.153.04-.252 0a17.792 17.792 0 0 0-3.403-1.258 14.38 14.38 0 0 0-3.611-.459 14.95 14.95 0 0 0-3.581.43c-1.165.286-2.28.715-3.345 1.287zm3.966 20.985c-1.144-1.184-2.037-2.427-2.678-3.73-.642-1.302-.962-2.811-.962-4.528 0-1.756.646-3.236 1.938-4.44 1.293-1.203 2.847-1.805 4.662-1.805s3.379.602 4.691 1.805c1.312 1.204 1.968 2.684 1.968 4.44 0 .099-.024.173-.074.222-.049.05-.123.074-.222.074a.357.357 0 0 1-.236-.074c-.06-.05-.089-.123-.089-.222 0-1.598-.597-2.94-1.791-4.025-1.194-1.085-2.61-1.628-4.247-1.628-1.638 0-3.044.543-4.218 1.628s-1.76 2.427-1.76 4.025c0 1.677.29 3.108.872 4.292.582 1.184 1.446 2.367 2.59 3.551.079.08.114.153.104.222a.34.34 0 0 1-.104.193.495.495 0 0 1-.192.103c-.09.03-.173-.005-.252-.103zm9.057-2.16c-1.736 0-3.241-.578-4.514-1.732-1.272-1.155-1.909-2.61-1.909-4.366 0-.099.025-.178.074-.237.05-.059.124-.089.222-.089.099 0 .173.03.222.09.05.058.074.137.074.236 0 1.598.587 2.915 1.761 3.951s2.531 1.554 4.07 1.554c.158 0 .345-.01.562-.03.217-.02.454-.049.711-.088.098-.02.177-.005.236.044.06.05.099.104.119.163a.29.29 0 0 1-.015.207c-.03.06-.094.099-.192.118a4.134 4.134 0 0 1-.933.163c-.266.01-.429.015-.488.015z"
          stroke="#174a6f"
          strokeWidth=".721"
        />
        <g
          clipPath="url(#6c0ynwxdib)"
          stroke="#174a6f"
          strokeWidth="1.428"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M24.968 49.594v2.922a1.461 1.461 0 0 1-1.461 1.461h-2.923M20.584 32.059h2.923a1.461 1.461 0 0 1 1.461 1.46v2.923M3.05 36.442V33.52a1.461 1.461 0 0 1 1.461-1.461h2.923M7.434 53.977H4.51a1.46 1.46 0 0 1-1.46-1.46v-2.923M14.01 44.113a4.018 4.018 0 1 0 0-8.037 4.018 4.018 0 0 0 0 8.037zM20.21 49.959a6.577 6.577 0 0 0-12.4 0" />
        </g>
        <path
          d="M53.937 47.918a5.612 5.612 0 1 0 0-11.225 5.612 5.612 0 0 0 0 11.225zM68.904 47.92a4.364 4.364 0 1 0-6.236 3.928v6.673l1.87 1.87 3.118-3.117-1.87-1.871 1.87-1.871-1.546-1.547a4.366 4.366 0 0 0 2.794-4.066zm-4.365 0a1.247 1.247 0 1 1 0-2.494 1.247 1.247 0 0 1 0 2.493zM58.851 50.438a7.482 7.482 0 0 0-3.043-.649h-3.741a7.483 7.483 0 0 0-7.483 7.483v2.495h16.213v-6.872a6.437 6.437 0 0 1-1.946-2.457z"
          fill="#174a6f"
        />
        <rect
          x="38.028"
          y="14.977"
          width="36.734"
          height="66.365"
          rx="2.118"
          stroke="#174a6f"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="lltze18o4a">
          <path fill="#fff" d="M0 0h110.4v96.001H0z" />
        </clipPath>
        <clipPath id="6c0ynwxdib">
          <path fill="#fff" transform="translate(2.32 31.328)" d="M0 0h23.379v23.379H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}
